import { render, staticRenderFns } from "./Rental-Items.vue?vue&type=template&id=161c63de"
import script from "./Rental-Items.vue?vue&type=script&lang=js"
export * from "./Rental-Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports